export const DivisionDeserializer = data => {
  return {
    id: data.id,
    title: data.title,
    level: { name: data.level.name },
    taker_count: data.taker_count,
    benchmark: {
      target: data.benchmark_count,
      achieved: data.count,
    },
  };
};
